/*** IMPORTS FROM imports-loader ***/
var define = false;

jQuery(document).ready(function($) {
  $('.hamburger').click(function(){
    $(this).toggleClass('is-active');
  });


  $('.hamburger').click(function(){
    $('.topnav-transparent').toggleClass('bg-dark');
    $('.topnav-transparent').toggleClass('bg-transparent');
  });



});

